import { checker, currentInNioCNAndroid, isObject } from '../util';
import storage from './storage';

export function getWebFUserInfo() {
    // @ts-ignore
    const info = window?.dsBridge?.call?.('getUserInfo', '');
    // 未登录的情况, 不对返回结果处理
    const { result_code } = info;
    if (result_code !== 'success') {
        return info;
    }

    // todo: [answer] 抽取出来, 跟 nativeBridge 公用 ?
    if (info.result_code === 'success') {
        // 补齐 account id
        const accountId = info.data.accountId || info.data.account_id;
        info.data.accountId = accountId;
        info.data.account_id = accountId;

        // 补齐 avatar
        info.data.avatar = info.data.avatar || '';

        // 补齐 displayLanguage
        if (!info.data.displayLanguage) {
            info.data.displayLanguage = '';
        }

        // 补齐 mobile
        const { mobile } = info.data;

        if (typeof mobile === 'string') {
            // todo 目前 CN Android 的 mobile 字段是 string 类型，暂时不做兼容，universal bridge 里调用 _getUserInfoV2 进行兼容
        } else {
            ['callingCode', 'calling_code', 'mobile'].forEach((item) => {
                info.data.mobile[item] = info.data.mobile[item] || '';
            });

            const callingCode = info.data.mobile.calling_code || info.data.mobile.callingCode;
            info.data.mobile.callingCode = callingCode;
            info.data.mobile.calling_code = callingCode;
        }

        if (currentInNioCNAndroid()) {
            // 补齐 nickName
            const { account_name } = info.data;
            info.data.nick_name = account_name;
            info.data.nickName = account_name;
        }

        // 补齐 countryCode
        if (!info.data.countryCode) {
            info.data.countryCode = '';
        }
    }

    return info;
}

/**
 * @description 对 getUserInfo 的格式进行兼容，用于 Universal Bridge
 */
export function getLGUserInfoV2(context = {}) {
    const info = getUserInfo(context);
    const { result_code, data = { access_token: '' } } = info;
    // iOS 未登录返回 unknown_error
    if (result_code !== 'success') {
        return info;
    }
    // Android 未登录, 返回 success, 但是没有值
    if (!data.access_token) {
        return info;
    }

    const { mobile } = info.data;

    if (typeof mobile === 'string') {
        info.data.mobile = {
            mobile,
            callingCode: '',
            calling_code: '',
        };
    }
    return info;
}

function getUserInfo(context = {}) {
    // @ts-ignore
    const info = window['dsBridge'].call('getUserInfo', context);
    const { result_code, data = { access_token: '' } } = info;

    // iOS 未登录返回 unknown_error
    if (result_code !== 'success') {
        return info;
    }
    // Android 未登录, 返回 success, 但是没有值
    if (!data.access_token) {
        return info;
    }

    if (info.result_code === 'success') {
        // 补齐 account id
        const accountId = info.data.accountId || info.data.account_id;
        info.data.accountId = accountId;
        info.data.account_id = accountId;

        // 补齐 avatar
        info.data.avatar = info.data.avatar || '';

        // 补齐 displayLanguage
        if (!info.data.displayLanguage) {
            info.data.displayLanguage = '';
        }

        // 补齐 mobile
        const { mobile } = info.data;

        if (typeof mobile === 'string') {
            // todo 目前 CN Android 的 mobile 字段是 string 类型，暂时不做兼容，universal bridge 里调用 _getUserInfoV2 进行兼容
        } else {
            ['callingCode', 'calling_code', 'mobile'].forEach((item) => {
                info.data.mobile[item] = info.data.mobile[item] || '';
            });

            const callingCode = info.data?.mobile?.calling_code || info.data?.mobile?.callingCode;
            info.data.mobile.callingCode = callingCode;
            info.data.mobile.calling_code = callingCode;
        }

        if (currentInNioCNAndroid()) {
            // 补齐 nickName
            const { account_name } = info.data;
            info.data.nick_name = account_name;
            info.data.nickName = account_name;
        }

        // 补齐 countryCode
        if (!info.data.countryCode) {
            info.data.countryCode = '';
        }
    }

    return info;
}

/**
 * @returns {object} appInfo
 */
export function getAppInfo() {
    // @ts-ignore
    return window?.dsBridge?.call?.('getAppInfo', '');
}

/**
 * @description 获取当前系统相关信息
 * @returns {object} osInfo
 */
export function getOSInfo() {
    // @ts-ignore
    return window?.dsBridge?.call?.('getOSInfo', '');
}

export function getDsBridge() {
    // @ts-ignore
    return window['dsBridge']; // web 前端调用的js 全局变量
}

export function dsBridgeRegister(context = {}) {
    checker(context);

    // @ts-ignore
    if (isObject(context.data)) {
        let info = {};
        let { data = {} } = getDsBridge().call('getOSInfo', '');
        let { osInfo = {} } = data;
        let { systemName = '' } = osInfo;
        if (systemName.toLowerCase() === 'android') {
            try {
                // android 参数处理方式
                info = getDsBridge().call('getCurrentPageInfo', '')['data'];
            } catch (ex) {
                console.error(ex);
            }
            storage.set({
                // @ts-ignore
                data: {
                    // @ts-ignore
                    key: info.objectId + '_' + context.event,
                    // @ts-ignore
                    value: context.data,
                },
            });
        }
    }

    // @ts-ignore
    getDsBridge().register(context.event, (result) => {
        // @ts-ignore
        context.callback(result);
    });
}
